/**
 * MIN-269: relocated from apps/provider/src/components/agent-chat/subject-banner.tsx.
 * The subject banner reflects the pinned patient: no pinned subject → no
 * banner. Pinned with no conflicting patient in view, or the same patient →
 * the plain "about" bar. Pinned while viewing a different patient → the
 * mismatch state offering a fresh chat. The React banner itself (which reads
 * app-specific route params and patient data) stays in each app; this is the
 * pure decision the banner renders from.
 */
export type SubjectBannerMode = "none" | "pinned" | "mismatch";

export function deriveSubjectBannerMode(
  subjectPatientId: string | null | undefined,
  ambientPatientId: string | null | undefined,
): SubjectBannerMode {
  if (!subjectPatientId) return "none";
  if (ambientPatientId && ambientPatientId !== subjectPatientId) return "mismatch";
  return "pinned";
}
